"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectToDataSubspace = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var TestIds_1 = require("../util/TestIds");
var ConnectToDataSubspace = function (props) {
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", null, props.subspaceTitle)),
        React.createElement("div", null,
            React.createElement("label", null, props.subspaceContent)),
        React.createElement(widgets_1.ButtonWidget, { onClick: function () { return props.greet('Connect'); }, testId: TestIds_1.CONNECT_BUTTON_SAY_HELLO_TEST_ID, buttonType: widgets_1.ButtonType.Primary }, 'Say Hello')));
};
exports.ConnectToDataSubspace = ConnectToDataSubspace;
//# sourceMappingURL=ConnectToDataSubspace.js.map